import { getTFunc } from '@icp/i18n';

export function mergeSearchTextToFilterModel(searchText, searchTextColIds, filterModel) {
  const searchColConditions = searchTextColIds.map((colId) => {
    return {
      colId,
      filterType: 'text',
      type: 'contains',
      filter: searchText,
    };
  });
  const searchColFilterModel =
    searchTextColIds.length > 1
      ? [
          {
            operator: 'OR',
            conditions: searchColConditions,
          },
        ]
      : searchColConditions;
  if (filterModel?.length) {
    filterModel = [
      {
        operator: 'AND',
        conditions: [...filterModel, ...searchColFilterModel],
      },
    ];
  } else {
    filterModel = searchColFilterModel;
  }
  return filterModel;
}

export function getDefaultColDef({ toolbarRef }) {
  const t = getTFunc('icp-vendor-aggrid');
  return {
    suppressHeaderFilterButton: true,
    mainMenuItems: (params) => {
      const { defaultItems } = params;
      const { colId } = params.column;

      let newItems = [...defaultItems];

      const filterIndex = newItems.indexOf('columnFilter');
      if (filterIndex !== -1 && toolbarRef.current?.openFilter) {
        newItems.splice(filterIndex, 1, {
          name: t('columnFilter'),
          action: () => {
            toolbarRef.current.openFilter(colId);
          },
          icon: '<span class="ag-icon ag-icon-filter" unselectable="on" role="presentation"></span>',
        });
        if (newItems[filterIndex - 1] === 'separator') {
          newItems.splice(filterIndex - 1, 1);
        }
      }

      const chooseIndex = newItems.indexOf('columnChooser');
      const columnItem = toolbarRef.current?.node.querySelector('.icp-table-toolbar-column-button');
      if (chooseIndex !== -1 && columnItem) {
        newItems.splice(chooseIndex, 1, {
          name: t('ariaHidden'),
          action: () => {
            params.api.setColumnsVisible([colId], false);
          },
          icon: '<span class="ag-icon ag-icon-eye-slash" unselectable="on" role="presentation"></span>',
        });
      }

      const itemsToExclude = ['columnFilter'];
      if (colId !== 'ag-Grid-AutoColumn' && !params.column.colDef.enableRowGroup) {
        itemsToExclude.push('rowGroup', 'rowUnGroup');
      }
      newItems = newItems.filter((item) => !itemsToExclude.includes(item));

      return newItems;
    },
  };
}
